import React from "react";

const SignedDocumentLightNeueIcon = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", Object.assign({
  width: 20,
  height: 20,
  viewBox: "0 0 12 12",
  fill: "none",
  ref: svgRef
}, props, {
  className: "transform-gpu " + (props.className || "")
}), /*#__PURE__*/React.createElement("rect", {
  width: 12,
  height: 12,
  rx: 6,
  fill: "#68BB3B"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3.75 6.39694L4.94118 7.72047L8.25 4.2793",
  stroke: "white",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SignedDocumentLightNeueIcon, Object.assign({
  svgRef: ref
}, props)));
export default ForwardRef;